<template>
    <div class="flex items-center gap-2 text-sm text-gray-500">
        <template
            v-for="(breadcrumb, index) in breadcrumbs"
            :key="index"
        >
            <a
                :href="breadcrumb.url"
                class="hover:text-gray-700"
            >
                {{ breadcrumb.title }}
            </a>
            <span v-if="index < breadcrumbs.length - 1">/</span>
        </template>
    </div>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import CMSBreadcrumb from '@/CMS/Content/Entity/CMSBreadcrumb'

    defineProps({
        breadcrumbs: {
            type: Array as PropType<CMSBreadcrumb[]>,
            required: true,
        },
    })
</script>
